<form [formGroup]="responsiblePartiesForm">
    <dx-popup
        class="popup"
        [width]="isPhoneOrTablet ? '90vw' : 840"
        [height]="'auto'"
        [showTitle]="true"
        [dragEnabled]="true"
        [closeOnOutsideClick]="false"
        [showCloseButton]="false"
        [(visible)]="popupVisible"
        [maxHeight]="'80vh'">
        <dxi-toolbar-item location="before">
            <h3 fxShow fxHide.lt-md style="margin: 5px 0">
                {{ id === -1 ? 'Add Responsible Party' : 'Edit Responsible Party' }}
            </h3>
            <h4 fxShow fxHide.gt-sm style="margin: 5px 0">
                {{ id === -1 ? 'Add Responsible Party' : 'Edit Responsible Party' }}
            </h4>
        </dxi-toolbar-item>
        <dxi-toolbar-item location="after">
            <dx-button text="Cancel" (click)="close()"></dx-button>
        </dxi-toolbar-item>
        <dxi-toolbar-item location="after">
            <dx-button text="Save" (click)="save()" style="margin-left: 8px;"></dx-button>
        </dxi-toolbar-item>

        <div *dxTemplate="let data of 'content'">
            <dx-scroll-view showScrollbar="onScroll">
                <div style="padding: 16px">
                    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                        <div fxLayout="column" fxFlex="30%" fxFlex.sm="50%" fxFlex.xs="100%"
                             fxLayoutAlign="space-between"
                             style="padding-right: 8px; margin-top: 32px" [ngStyle.xs]="{'padding-right': '0'}">
                            <div class="dx-field" style="width: 100% !important;">
                                <div class="dx-field-label">Last Name <span class="ocl-required-indicator">*</span>
                                </div>
                                <div class="dx-field-value" style="width: 100% !important;">
                                    <dx-text-box class="uppercase" formControlName="lastName">
                                        <dx-validator validationGroup="responsibleParty">
                                            <dxi-validation-rule type="required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field" style="width: 100% !important;">
                                <div class="dx-field-label">First Name <span class="ocl-required-indicator">*</span>
                                </div>
                                <div class="dx-field-value" style="width: 100% !important;">
                                    <dx-text-box class="uppercase" formControlName="firstName">
                                        <dx-validator validationGroup="responsibleParty">
                                            <dxi-validation-rule type="required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field" style="width: 100% !important; padding-right: 2px!important;">
                                <div class="dx-field-label">Phone <span class="ocl-required-indicator">*</span></div>
                                <div class="dx-field-value" style="width: 100% !important;">
                                    <dx-text-box
                                        formControlName="phone"
                                        mask="000-000-0000"
                                        [maskRules]="phoneMaskRule"
                                    >
                                        <dx-validator validationGroup="responsibleParty">
                                            <dxi-validation-rule type="required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field" style="width: 100% !important; padding-right: 2px!important;">
                                <div class="dx-field-label">Mobile</div>
                                <div class="dx-field-value" style="width: 100% !important;">
                                    <dx-text-box
                                        formControlName="mobile"
                                        mask="000-000-0000"
                                        [maskRules]="phoneMaskRule"
                                    ></dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field" style="width: 100% !important; padding-right: 2px!important;">
                                <div class="dx-field-label">Fax</div>
                                <div class="dx-field-value" style="width: 100% !important;">
                                    <dx-text-box
                                        formControlName="fax"
                                        mask="000-000-0000"
                                        [maskRules]="phoneMaskRule"
                                    ></dx-text-box>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="column" fxFlex="70%" fxFlex.sm="50%" fxFlex.xs="100%">
                            <app-address
                                style="width: 100%!important"
                                [addressControl]="convertToFormControl(responsiblePartiesForm.get('address'))"
                                [zipCodeControl]="convertToFormControl(responsiblePartiesForm.get('zipCode'))"
                                [zipCodeExtraControl]="convertToFormControl(responsiblePartiesForm.get('zipCodeExtra'))"
                                [required]="true"
                                [validationGroup]="'address'"
                            ></app-address>
                        </div>
                    </div>
                </div>
            </dx-scroll-view>
        </div>
    </dx-popup>
</form>
